import Icon from '../components/Icon.vue'

Icon.register({
  tools: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M501.1 395.7L384 278.6C360.9 255.5 326.4 251 298.6 264.7L192 158.1V96L64 0 0 64 96 192H158.1L264.7 298.6C251.1 326.4 255.5 360.9 278.6 384L395.7 501.1C410.3 515.7 433.9 515.7 448.4 501.1L501.1 448.4C515.6 433.8 515.6 410.2 501.1 395.7zM331.7 225C360 225 386.6 236 406.6 256L426 275.4C441.8 268.5 456.8 258.9 469.8 245.9 506.9 208.8 519.5 156.6 507.7 109.2 505.5 100.2 494.2 97.1 487.6 103.7L413.2 178.1 345.3 166.8 334 98.9 408.4 24.5C415 17.9 411.8 6.6 402.7 4.3 355.3-7.4 303.1 5.2 266.1 42.2 237.6 70.7 224.2 108.3 224.9 145.8L307 227.9C315.1 226 323.5 225 331.7 225zM227.8 307L171.1 250.3 18.7 402.8C-6.3 427.8-6.3 468.3 18.7 493.3S84.2 518.3 109.2 493.3L232.8 369.7C225.2 349.8 222.9 328.1 227.8 307zM64 472C50.8 472 40 461.2 40 448 40 434.7 50.7 424 64 424S88 434.7 88 448C88 461.2 77.3 472 64 472z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/tools.js
// module id = aLLN
// module chunks = 144